import * as THREE from 'three';
import Sizes from './Utils/Sizes';
import Time from './Utils/Time';
import Mouse from './Utils/Mouse';
import Loading from './Utils/Loading';
import Resources from './Utils/Resources';
import Camera from './Camera/Camera';
import Renderer from './Renderer';
import World from './World/World';
import AudioManager from './Audio/AudioManager';
import sources from './sources';
import UI from './UI/UI';

let instance: Application | null = null;

export default class Application {
    canvas!: HTMLCanvasElement;
    sizes!: Sizes;
    time!: Time;
    mouse!: Mouse;
    loading!: Loading;
    scene!: THREE.Scene;
    cssScene!: THREE.Scene;
    resources!: Resources;
    camera!: Camera;
    renderer!: Renderer;
    world!: World;
    audio!: AudioManager;
    ui!: UI;

    constructor() {
        if (instance) return instance;
        instance = this;

        const c = document.querySelector('canvas.webgl');
        if (!c) throw new Error('canvas.webgl not found');
        this.canvas = c as HTMLCanvasElement;

        this.sizes = new Sizes();
        this.time = new Time();
        this.mouse = new Mouse();
        this.loading = new Loading();
        this.scene = new THREE.Scene();
        this.cssScene = new THREE.Scene();
        this.resources = new Resources(sources);
        this.camera = new Camera();
        this.renderer = new Renderer();
        this.camera.createControls();
        this.audio = new AudioManager();
        this.world = new World();
        this.ui = new UI();

        this.sizes.on('resize', () => this.resize());
        this.time.on('tick', () => this.update());
    }

    private resize() {
        this.camera.resize();
        this.renderer.resize();
    }

    private update() {
        this.camera.update();
        this.world.update();
        this.renderer.update();
    }
}
